import * as React from "react";

function SvgIconFeatherHome(props) {
  return (
    <svg width={23.6} height={26} {...props}>
      <g
        data-name="Icon feather-home"
        fill="none"
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          data-name="Caminho 61"
          d="M1 9.4L11.8 1l10.8 8.4v13.2a2.4 2.4 0 01-2.4 2.4H3.4A2.4 2.4 0 011 22.6z"
        />
        <path data-name="Caminho 62" d="M8.2 25V13h7.2v12" />
      </g>
    </svg>
  );
}

export default SvgIconFeatherHome;
